
import { required, email } from 'vuelidate/lib/validators'
import { mapGetters, mapActions } from 'vuex'
import ReviewStars from './review-stars'
import LoleP from '~/components/text/lole-p'
import LoleBtn from '~/components/buttons/lole-btn'
import Input from '~/components/form/input/Input'
import LoleSelect from '~/components/form/select/lole-select'
import LoleTextarea from '~/components/form/textarea/lole-textarea'
import Checkbox from '~/components/form/checkbox/Checkbox'

export default {
  components: {
    LoleP,
    LoleBtn,
    Input,
    LoleSelect,
    LoleTextarea,
    Checkbox,
    ReviewStars,
  },
  inject: ['product', 'wording'],
  data: () => ({
    reviewForm: {
      productId: null,
      name: '',
      email: '',
      location: null,
      rating: 0,
      title: '',
      body: '',
      productName: '',
      productSKU: '',
      productUrl: '',
      reviewSource: 'lole headless',
      customerHeight: '',
      productSize: '',
      usualSize: '',
    },
    heightOptions: [
      "< 4'11 (< 1m50)",
      "5'0 – 5'2 (1m51 - 1m58)",
      '5’3 – 5’5 (1m59 - 1m66)',
      '5’6 – 5’8 (1m67 - 1m73)',
      '5’9 – 5’11 (1m74 - 1m81)',
      '6’0 – 6’2 (1m82 - 1m88)',
      '6’3 – 6’5 (1m89 - 1m95)',
      "> 6'6 (> 1m96)",
    ],
    reviewMaxLength: 300,
    acceptTerms: false,
    submitted: false,
    sending: false,
    productReviewed: false,
    ratingError: false,
    errors: [],
  }),
  validations: {
    reviewForm: {
      rating: { required },
      name: { required },
      email: { required, email },
      title: { required },
      body: { required },
      productSize: { required },
      usualSize: { required },
      customerHeight: { required: false },
    },
  },
  computed: {
    ...mapGetters({
      wordingErrors: 'common/getErrorsForm',
      vxCustomer: 'customer/getCustomer',
      vxLoyalty: 'loyalty/getProfile',
      vxCurency: 'currency/getCurrency',
    }),
    reviewCharCount() {
      return this.reviewForm.body.length
    },
    ratingScore() {
      return this.reviewForm.rating
    },
    internalType() {
      return this.product.internal_type
    },
    customerName() {
      if (this.vxCustomer) {
        return this.vxCustomer.firstName && this.vxCustomer.lastName
          ? `${this.vxCustomer.firstName} ${this.vxCustomer.lastName.substr(
              0,
              1
            )}.`
          : ''
      } else {
        return ''
      }
    },
    productId() {
      return this.product.id.replace('gid://shopify/Product/', '')
    },
  },
  watch: {
    ratingScore() {
      if (this.ratingScore > 0) {
        this.ratingError = false
      }
    },
  },
  async mounted() {
    // SET PRODUCT INFO IN REVIEW FORM
    this.reviewForm.productSKU = this.internalType
    this.reviewForm.productName = `${this.product.title} ${this.product.sample_color}`
    this.reviewForm.productUrl = window.location.href

    // INITIALIZE RECAPTCHA CLIENT-SIDE
    try {
      await this.$recaptcha.init()
    } catch (error) {
      this.$sentryException(error, {
        source: 'PDP - Product Reviews',
        level: 'warning',
        extra: 'Product Review Form - failed initialize recaptcha',
      })
    }

    if (this.vxCustomer) {
      this.reviewForm.name = this.customerName
      this.reviewForm.email = this.vxCustomer.email
    }
  },
  beforeDestroy() {
    this.$recaptcha.destroy()
  },
  methods: {
    ...mapActions({
      vxAwardPoints: 'loyalty/awardPoints',
    }),
    async submitReview() {
      // CHECK HAS STAR RATING
      this.ratingError = this.reviewForm.rating === 0

      // TRY-CATCH RECAPTCHA
      let recaptchaToken = null
      try {
        recaptchaToken = await this.$recaptcha.execute('login')
      } catch (error) {
        this.$sentryException(error, {
          source: 'PDP - Product Reviews',
          level: 'warning',
          extra: 'Product Review Form - failed to get recaptcha token',
        })
      }

      // TRY-CATCH SUBMIT FORM
      try {
        this.$v.$touch()
        this.submitted = true
        this.errors = []
        if (
          !this.$v.$invalid &&
          this.ratingError === false &&
          this.acceptTerms
        ) {
          this.reviewForm.productId = this.product.id.replace(
            'gid://shopify/Product/',
            ''
          )
          this.reviewForm.location = this.$i18n.locale

          // CUSTOM FORM QUESTIONS
          const cf_answers = []
          if (this.reviewForm.productSize) {
            cf_answers.push({
              cf_question_id: 94017,
              value: this.reviewForm.productSize,
            })
          }
          if (this.reviewForm.usualSize) {
            cf_answers.push({
              cf_question_id: 94018,
              value: this.reviewForm.usualSize,
            })
          }
          if (this.reviewForm.customerHeight) {
            cf_answers.push({
              cf_question_id: 94019,
              value: this.reviewForm.customerHeight,
            })
          }

          this.reviewForm.cf_answers = cf_answers

          // send token to server alongside your form data
          this.sending = true
          await this.$axios
            .post('/api/judgeme/reviews/create', {
              recaptchaToken,
              reviewRequest: this.reviewForm,
            })
            .then(() => {
              // TODO: INVALIDATE REDIS CACHE
              // const reviewsDataKey = `jdgme-reviews__${this.productId}`
              // this.$redisClient.delete(reviewsDataKey)

              setTimeout(() => {
                this.productReviewed = true
              }, 800)
            })
        }
      } catch (error) {
        this.productReviewed = false
        this.sending = false
        this.$sentryException(error, {
          source: 'PDP - Product Reviews',
          level: 'warning',
          extra: 'Product Review Form - failed submit customer review',
        })
      }
    },
  },
}
